@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.email-return-label-body {
  padding: 15px;
  max-height: 600px;
}

.instructions {
  color: @email-return-label-modal--instructions--text-color;
  font-size: 14px;
  margin-bottom: 10px;
}

.email-to-text-area {
  width: 100%;
  min-height: 120px;
}

.comma-separated-instructions {
  font-size: 12px;
  color: @email-return-label-modal--comma-separated-instructions--text-color;
  margin: 10px 0;
  padding-bottom: 10px;
}

.border-bottom {
  border-bottom: 1px solid @email-return-label-modal--border-color;
}

.footer {
  > button {
    margin-left: 10px;
  }
}

.return-line {
  height: 42px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid @email-return-label-modal--border-color;
  margin-top: 15px;
  padding-bottom: 15px;

  .big-float-input {
    width: 350px;
  }
}

.rma-number {
  font-size: 18px;
}
